"use client";

import { UserRound } from "lucide-react";
import { Avatar, AvatarFallback } from "~/components/ui/avatar";
import { TijanaAvatar } from "~/components/tijana/avatar";
import { cn } from "~/lib/utils";

/**
 * Tijana's variant of the house chat bubble (~/components/chat/components/message-bubble.tsx),
 * reusing the exact same bubble/layout classes so it looks and feels like every
 * other chat surface in the app. The one intentional difference: the assistant
 * avatar is Tijana's illustrated portrait with its "AI" disclosure badge,
 * since that badge must ride along with her wherever she appears.
 */
export function TijanaMessageBubble({
  isMine,
  children,
}: {
  isMine?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className={cn("group flex gap-2", isMine && "justify-end")}>
      <div
        className={cn(
          "flex max-w-[88%] items-start gap-2 sm:max-w-[80%]",
          isMine && "flex-row-reverse",
        )}
      >
        <div className="shrink-0">
          {isMine ? (
            <Avatar className="h-8 w-8">
              <AvatarFallback className="bg-brand/10 text-brand">
                <UserRound className="h-4 w-4" aria-hidden="true" />
              </AvatarFallback>
            </Avatar>
          ) : (
            <TijanaAvatar size={32} rounded="full" />
          )}
        </div>
        <div
          className={cn(
            "overflow-hidden",
            isMine
              ? "bg-brand-action text-brand-foreground min-w-14 rounded-2xl rounded-tr-md"
              : "border-border bg-secondary rounded-2xl rounded-tl-md border shadow-xs",
          )}
        >
          <div className="px-3 py-2">
            <div className="text-sm wrap-break-word">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
